export default __webpack_public_path__ + "static/media/brand-logo-white-small.f02100af.svg";